import Calendario from '../../spa/calendario/Calendario';

export default {
  path: 'calendario',
  name: 'calendario',
  component: Calendario,
};
